import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { ToggleRight } from "@phosphor-icons/react";
import { toast } from "sonner";

/** Super-admin → Módulos ativos: global switches, off by default. Off hides for clients; data is kept. */
export function FeatureSwitches() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/platform/features").then(({ data }) => setD(data)).catch((e) => toast.error(apiError(e))); }, []);
  if (!d) return null;
  const toggle = async (k, v) => {
    const values = { ...d.values, [k]: v };
    setD({ ...d, values });
    try { const { data } = await api.put("/platform/features", values); setD(data); toast.success(`${d.labels[k]}: ${v ? "ligado" : "desligado"}`); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <section className="rounded-2xl border border-border bg-card p-5" data-testid="feature-switches">
      <h2 className="flex items-center gap-2 font-display text-lg font-bold"><ToggleRight size={22} /> Módulos ativos</h2>
      <p className="mt-1 text-sm text-muted-foreground">Desligado = escondido do menu, das páginas e da página inicial para os clientes. Os dados ficam guardados.</p>
      <div className="mt-4 grid gap-2 sm:grid-cols-2">
        {Object.entries(d.labels).map(([k, label]) => (
          <label key={k} className="flex items-center justify-between gap-3 rounded-xl border border-border px-4 py-3 text-sm font-medium">
            {label}
            <Switch checked={!!d.values[k]} onCheckedChange={(v) => toggle(k, v)} data-testid={`feature-switch-${k}`} />
          </label>
        ))}
      </div>
    </section>
  );
}
